import { customerTags, opportunityTags, tags } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

// Tag schemas
export const selectTagSchema = createSelectSchema(tags)
export const insertTagSchema = createInsertSchema(tags).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})
export const updateTagSchema = insertTagSchema.partial()

// Opportunity tag schemas
export const selectOpportunityTagSchema = createSelectSchema(opportunityTags)

// Opportunity tag with tag details for display
export const selectOpportunityTagWithDetailsSchema =
  selectOpportunityTagSchema.extend({
    tag: selectTagSchema,
  })

// Customer tag schemas
export const selectCustomerTagSchema = createSelectSchema(customerTags)

export const selectCustomerTagWithDetailsSchema =
  selectCustomerTagSchema.extend({
    tag: selectTagSchema,
  })

// Type exports
export type Tag = z.infer<typeof selectTagSchema>
export type InsertTag = z.infer<typeof insertTagSchema>
export type UpdateTag = z.infer<typeof updateTagSchema>
export type OpportunityTag = z.infer<typeof selectOpportunityTagSchema>
export type OpportunityTagWithDetails = z.infer<
  typeof selectOpportunityTagWithDetailsSchema
>
export type CustomerTag = z.infer<typeof selectCustomerTagSchema>
export type CustomerTagWithDetails = z.infer<
  typeof selectCustomerTagWithDetailsSchema
>
